// src/utils/validateName.ts

import * as Yup from 'yup';
import { yupNameValidationSchema } from '../Service/nameValidation';

export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export type validationNameType =
  | 'first_name'
  | 'last_name'
  | 'name'
  | 'sponsor_name'
  | 'main_contact'
  | 'email_address'
  | 'phone_number'
  | 'title'
  | 'email';

export const validateName = async (
  value: string,
  field: validationNameType,
): Promise<ValidationResult> => {
  try {
    await yupNameValidationSchema.validateAt(field, {[field]: value.trim()});
    return {isValid: true, errors: []};
  } catch (error: unknown) {
    if (error instanceof Yup.ValidationError) {
      return {isValid: false, errors: [error.message]};
    }
    return {isValid: false, errors: ['Something went wrong.']};
  }
};

const urlSchema = Yup.string().url('Please enter a valid URL.');

export function validateUrl(url: string): boolean {
  return urlSchema.isValidSync(url);
}
